import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Icon } from "@iconify/react";
import moment from "moment";
import { convertCurrencyToSignNew } from "../../utils/Constant";

const styles = {
  container: {
    width: "100%",
    minHeight: "95vh",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 3,
  },
  successIcon: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    backgroundColor: "#F5CE6E",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 3,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  title: {
    fontWeight: 800,
    color: "#222",
    marginBottom: 1,
    textAlign: "center",
  },
  subtitle: {
    color: "#555",
    marginBottom: 4,
    fontSize: 16,
    maxWidth: 500,
    textAlign: "center",
    lineHeight: 1.6,
  },
  paymentDetailsCard: {
    backgroundColor: "#f9f9f9",
    borderRadius: 3,
    padding: 3,
    width: "100%",
    maxWidth: 500,
    marginBottom: 4,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  detailRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    marginBottom: 2,
  },
  detailLabel: {
    color: "#777",
    marginBottom: 0.5,
    fontWeight: 500,
  },
  amountText: {
    fontWeight: 700,
    fontSize: 18,
  },
  dateText: {
    fontWeight: 700,
    fontSize: 16,
  },
  continueButton: {
    background: "var(--portal-primary-color)",
    color: "#fff",
    fontWeight: "bold",
    paddingX: 4,
    paddingY: 1.5,
    textTransform: "none",
    "&:hover": {
      background: "var(--portal-primary-color)",
      opacity: 0.9,
    },
  },
};

function PaymentSuccessCard({
  paymentRequestDetails,
  amount,
  currency,
  onClose,
}) {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.successIcon}>
        <Icon icon="mdi:check-bold" color="#fff" width={48} height={48} />
      </Box>

      <Typography variant="h4" sx={styles.title}>
        Thank You For Your Subscription
      </Typography>

      <Typography sx={styles.subtitle}>
        We are pleased to confirm that your subscription has been successfully
        activated. Your timely settlement is greatly appreciated, and we look
        forward to continuing to serve you with the highest level of excellence.
      </Typography>

      <Typography sx={styles.subtitle}>
        You’ll receive a confirmation email with all relevant details at your
        registered email address for your records.
      </Typography>

      <Box sx={styles.paymentDetailsCard}>
        <Box sx={styles.detailRow}>
          <Icon
            icon="mdi:credit-card-outline"
            width={20}
            height={20}
            color="#F5CE6E"
          />
          <Box>
            <Typography variant="body2" sx={styles.detailLabel}>
              Amount Paid:
            </Typography>
            <Typography sx={styles.amountText}>
              {convertCurrencyToSignNew(currency)}
              {paymentRequestDetails.plan.trial_period_days > 0
                ? 0
                : amount.toFixed(2)}
            </Typography>
          </Box>
        </Box>
        {paymentRequestDetails.plan.trial_period_days > 0 && (
          <Box sx={styles.detailRow}>
            <Icon
              icon="mdi:cash-multiple"
              width={20}
              height={20}
              color="#F5CE6E"
            />
            <Box>
              <Typography variant="body2" sx={styles.detailLabel}>
                Amount To Be Paid After Trial:
              </Typography>
              <Typography sx={styles.amountText}>
                {convertCurrencyToSignNew(currency)}
                {amount.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        )}

        <Box sx={styles.detailRow}>
          <Icon icon="uiw:date" width={20} height={20} color="#F5CE6E" />
          <Box>
            <Typography variant="body2" sx={styles.detailLabel}>
              {paymentRequestDetails.plan.trial_period_days > 0
                ? "Trial End On"
                : "Date of Payment:"}
            </Typography>
            <Typography sx={styles.dateText}>
              {moment()
                .add(paymentRequestDetails.plan.trial_period_days, "days")
                .format("MMMM DD, YYYY")}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Button sx={styles.continueButton} onClick={onClose}>
        Continue
      </Button>
    </Box>
  );
}

export default PaymentSuccessCard;
